; (function (jQuery) {

    "use strict";

    function Main() {
        var global = {
        };

        var fn = {
            init: function () {
                jQuery('.no-js').removeClass('no-js');

				jQuery('main').fitVids({
                    customSelector: 'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
                });
            }
        }

        jQuery(fn.init);
    }

    new Main();
})(jQuery);